import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

const Refund = () => {
  return (
    <>
      <>
      {/* <Header/> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
  
      <>
      {/* Section 1 – Heading + Description */}
      <section className="ib-refund-hero">
        <div className="ib-refund-hero-inner">
          <span className="ib-refund-eyebrow">Website Policy</span>
          <h1 className="ib-refund-title">Refunds &amp; Cancellation Policy</h1>
          <p className="ib-refund-desc">
            Clear cancellation, rescheduling and refund terms for Indiaboats
            yacht charters, speedboat transfers, curated packages, yacht parties
            and corporate events.
          </p>
          <div className="ib-refund-meta">
            <span>Last updated: 2 September 2026</span>
            <span>Operated by Aquartia Pvt. Ltd.</span>
          </div>
        </div>
      </section>

      {/* Section 2 – Sidebar + Right Content */}
      <main className="ib-refund-shell">
        {/* Left Sidebar (TOC) */}
        <aside className="ib-refund-toc" aria-label="Policy contents">
          <div className="ib-refund-toc-title">On this page</div>
          <nav className="ib-refund-toc-nav">
            <a href="#purpose">1. Purpose</a>
            <a href="#standard-guest-cancellation-charges">2. Standard Guest Cancellation Charges</a>
            <a href="#yacht-parties-corporate-events-and-supplier-heavy-bookings">3. Yacht Parties, Corporate Events and Supplier-Heavy Bookings</a>
            <a href="#speedboat-transfers-and-destination-packages">4. Speedboat Transfers and Destination Packages</a>
            <a href="#rescheduling-requested-by-the-guest">5. Rescheduling Requested by the Guest</a>
            <a href="#weather-rain-tide-and-sea-conditions">6. Weather, Rain, Tide and Sea Conditions</a>
            <a href="#cancellation-or-material-change-by-indiaboats">7. Cancellation or Material Change by Indiaboats</a>
            <a href="#late-arrival-no-show-and-missed-departure">8. Late Arrival, No-Show and Missed Departure</a>
            <a href="#early-return-or-trip-termination">9. Early Return or Trip Termination</a>
            <a href="#activity-or-itinerary-changes">10. Activity or Itinerary Changes</a>
            <a href="#how-to-cancel-or-request-a-refund">11. How to Cancel or Request a Refund</a>
            <a href="#refund-processing">12. Refund Processing</a>
            <a href="#consumer-rights">13. Consumer Rights</a>
            <a href="#policy-changes">14. Policy Changes</a>
          </nav>
        </aside>

        {/* Right Content */}
        <article className="ib-refund-content">
          <div className="ib-refund-intro">
            <strong>Clear terms before you book.</strong> Vessels, crew, jetties
            and suppliers are reserved specifically for confirmed bookings, so
            cancellation terms vary according to timing and the type of
            experience.
          </div>

          <section className="ib-refund-section" id="purpose">
            <h2>1. Purpose</h2>
            <p>
              Vessels, crew, jetties and suppliers are reserved specifically for
              each confirmed booking. This policy explains how guest-requested
              cancellations, no-shows, rescheduling, weather and operator-led
              changes are handled. Booking-specific terms may apply to special
              packages, large parties or corporate events and will be
              communicated before payment where applicable.
            </p>
          </section>

          <section className="ib-refund-section" id="standard-guest-cancellation-charges">
            <h2>2. Standard Guest Cancellation Charges</h2>
            <p>
              Unless a quotation or booking confirmation states a different
              policy, the following standard cancellation charges apply to
              private yacht charters, sailing experiences and similar standard
              bookings. The cancellation period is calculated from the confirmed
              departure time.
            </p>

            <div className="ib-refund-table-wrap">
              <table className="ib-refund-table">
                <thead>
                  <tr>
                    <th>Cancellation received</th>
                    <th>Cancellation charge</th>
                    <th>Refund of eligible booking amount*</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>72 hours or more before departure</td>
                    <td>25%</td>
                    <td>75%</td>
                  </tr>
                  <tr>
                    <td>48 to less than 72 hours before departure</td>
                    <td>50%</td>
                    <td>50%</td>
                  </tr>
                  <tr>
                    <td>24 to less than 48 hours before departure</td>
                    <td>75%</td>
                    <td>25%</td>
                  </tr>
                  <tr>
                    <td>Less than 24 hours before departure</td>
                    <td>100%</td>
                    <td>No refund</td>
                  </tr>
                  <tr>
                    <td>No-show / missed departure caused by guest</td>
                    <td>100%</td>
                    <td>No refund</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="ib-refund-note">
              <strong>Eligible booking amount:</strong> the amount actually
              received for the service, after excluding any non-refundable
              third-party costs, payment reversals or charges that were
              expressly disclosed and lawfully applicable.
            </div>
          </section>

          <section className="ib-refund-section" id="yacht-parties-corporate-events-and-supplier-heavy-bookings">
            <h2>3. Yacht Parties, Corporate Events and Supplier-Heavy Bookings</h2>
            <p>
              Large yacht parties, corporate events, sailing regattas, awards
              events, networking events and customised packages often require
              advance commitments to vessels and third-party suppliers. Unless
              different terms are agreed in writing:
            </p>
            <p>
              For cancellation more than 72 hours before the event, at least 50%
              of the booking amount may be retained.
            </p>
            <p>
              For cancellation within 72 hours of the event, the booking amount
              is non-refundable.
            </p>
            <p>
              Committed or non-recoverable supplier costs may be retained in
              addition to the applicable cancellation charge where those costs
              were reasonably incurred for the booking.
            </p>
            <p>
              Where event-specific cancellation terms are stated in the quotation
              or booking confirmation, those terms will apply to that booking to
              the extent permitted by law.
            </p>
          </section>

          <section className="ib-refund-section" id="speedboat-transfers-and-destination-packages">
            <h2>4. Speedboat Transfers and Destination Packages</h2>
            <p>
              Speedboat transfers and curated Mandwa, Alibaug or Elephanta
              packages may involve boat allocation, local transport, guides,
              permissions, entry arrangements, catering or other suppliers. The
              standard cancellation table applies unless the quotation states
              otherwise, but non-recoverable supplier or statutory costs that
              were specifically committed for your booking may be deducted where
              permitted by law.
            </p>
          </section>

          <section className="ib-refund-section" id="rescheduling-requested-by-the-guest">
            <h2>5. Rescheduling Requested by the Guest</h2>
            <p>
              A request to change the date, time, route, vessel or experience is
              not automatically accepted. Rescheduling is subject to vessel and
              supplier availability, operational feasibility, pricing differences
              and human approval by the Indiaboats team. If a requested change
              cannot be accommodated, the original booking and applicable
              cancellation terms remain in effect unless otherwise agreed in
              writing.
            </p>
          </section>

          <section className="ib-refund-section" id="weather-rain-tide-and-sea-conditions">
            <h2>6. Weather, Rain, Tide and Sea Conditions</h2>
            <p>
              Rain, a weather forecast or a guest’s personal concern about
              weather does not automatically cancel a booking or create a right
              to a refund. Marine conditions can change quickly, and only
              Indiaboats, the captain, vessel operator or other authorised
              personnel may determine that conditions are unsafe or that a trip
              should be delayed, changed, rescheduled or cancelled.
            </p>
            <p>
              If the guest cancels while the trip remains operationally approved,
              the guest-cancellation charges above apply. If authorised personnel
              determine that the service cannot safely operate, Indiaboats will
              review the booking for rescheduling, credit or refund as
              appropriate, taking into account the service not delivered,
              non-recoverable third-party costs, booking-specific terms and
              applicable law. Such cases require human review and written
              confirmation.
            </p>
          </section>

          <section className="ib-refund-section" id="cancellation-or-material-change-by-indiaboats">
            <h2>7. Cancellation or Material Change by Indiaboats</h2>
            <p>
              If Indiaboats cannot provide the confirmed service because of
              vessel unavailability, technical/safety reasons, regulatory
              restrictions or another operational issue, we may first offer a
              reasonably comparable substitute or rescheduling. If no reasonable
              alternative is accepted or available, we will provide the refund or
              other remedy required by the booking terms and applicable law for
              the affected service. Non-recoverable third-party amounts will be
              handled fairly and in accordance with applicable consumer law.
            </p>
          </section>

          <section className="ib-refund-section" id="late-arrival-no-show-and-missed-departure">
            <h2>8. Late Arrival, No-Show and Missed Departure</h2>
            <p>
              Guests should report at the time stated in their confirmation; for
              yacht charters this is normally about 20 minutes before departure.
              Late arrival may reduce the usable charter time because the
              booking may still need to end at the original time. A missed
              departure or no-show caused by the guest is treated as a 100%
              cancellation charge. Any extension or alternate departure is
              subject to availability, safety and additional charges.
            </p>
          </section>

          <section className="ib-refund-section" id="early-return-or-trip-termination">
            <h2>9. Early Return or Trip Termination</h2>
            <p>
              No automatic refund is due where a guest voluntarily ends an
              experience early, becomes unable or unwilling to continue, or where
              the captain terminates or restricts the trip because of unsafe
              guest conduct, prohibited items, intoxication, violence, refusal
              to follow safety instructions or other guest-caused risk. Any
              legally required remedy remains unaffected.
            </p>
          </section>

          <section className="ib-refund-section" id="activity-or-itinerary-changes">
            <h2>10. Activity or Itinerary Changes</h2>
            <p>
              Swimming, kayaking, sailing route, anchorage, destination timing,
              sightseeing or other activities may be modified or omitted if
              weather, tide, sea conditions, permissions, harbour control or
              safety requirements make them unsuitable. A minor operational
              change that does not materially reduce the core booked service will
              not automatically create a refund entitlement. Material shortfalls
              will be reviewed fairly under the booking terms and applicable
              law.
            </p>
          </section>

          <section className="ib-refund-section" id="how-to-cancel-or-request-a-refund">
            <h2>11. How to Cancel or Request a Refund</h2>
            <p>
              Cancellation, rescheduling and refund requests must be made through
              an official Indiaboats customer-care channel and include the
              booking name, booking date, mobile number and booking/payment
              reference. A request is considered received when acknowledged by
              our team.
            </p>
            <p>
              <strong>Email:</strong> customercare@indiaboats.in
            </p>
            <p>
              <strong>Customer Care:</strong> +91 85919 93301 / +91 90040 13301 /
              +91 85919 83301 / 022 6695 8111
            </p>
          </section>

          <section className="ib-refund-section" id="refund-processing">
            <h2>12. Refund Processing</h2>
            <p>
              All refunds require review and approval by an authorised Indiaboats
              team member. Once approved, refunds will ordinarily be returned to
              the original payment method where practicable. Actual bank or
              payment-gateway credit time may vary. Any processing timeline
              communicated by us begins after approval, not from the date of the
              initial request.
            </p>
          </section>

          <section className="ib-refund-section" id="consumer-rights">
            <h2>13. Consumer Rights</h2>
            <p>
              Nothing in this policy is intended to remove or limit rights that
              cannot lawfully be excluded under the Consumer Protection Act,
              2019, the Consumer Protection (E-Commerce) Rules, 2020 or other
              applicable law. Where a service is deficient, materially different
              from what was agreed, or otherwise attracts a mandatory consumer
              remedy, the applicable law will prevail over any inconsistent part
              of this policy.
            </p>
          </section>

          <section className="ib-refund-section" id="policy-changes">
            <h2>14. Policy Changes</h2>
            <p>
              We may update this policy from time to time. The version provided
              or linked at the time your booking is confirmed will generally apply
              to that booking, together with any booking-specific written
              cancellation terms.
            </p>
          </section>

         {/* Policy Links – Pill Buttons */}
<div className="ib-privacy-links">
  <a href="/privacy" className="ib-privacy-link">Privacy Policy</a>
  <a href="/terms" className="ib-privacy-link">Terms of Use</a>
  <a href="/refund" className="ib-privacy-link">Refund Policy</a>
  <a href="/contact" className="ib-privacy-link">Contact Indiaboats</a>
</div>  
        </article>
      </main>
    </>
      
  <Footer/>
</>

    </>
  );
};

export default Refund;
